import TitleBlock from '@anm/components/TitleBlock';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const RelativeBlock = styled.div`
  position: relative;
`;

export const ParamsButton = styled.span`
  top: 0;
  right: 0;
  z-index: 2;
  color: var(--blue_100);
  font-size: 14px;
  cursor: pointer;
  position: absolute;
`;

export const ParamsDescription = styled.p`
  margin: 0;
  color: #292a2b;
  font-size: 14px;
  line-height: 22px;
  margin: -4px 0 12px;
`;

const SectionSubTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.01em;
    color: #919eaa;
    font-weight: normal;
  }
`;

export const Subtitle = styled(SectionSubTitle)`
  margin-bottom: 7px;
`;

export const SwitcherTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -3px;
  ${Subtitle} {
    margin-bottom: 0;
  }
`;

export const ParamsWrapper = styled.div``;

const copyLinkButtonOnMobiles = media.tablet`
    margin: 0 auto;
`;

export const CopyLinkWrapper = styled.div`
  button {
    ${copyLinkButtonOnMobiles}
  }
`;
